// extracted by mini-css-extract-plugin
module.exports = {"list":"styles_list__cQ77M","list_item":"styles_list_item__DbI3j","more":"styles_more__2Tt7C"};